import React from 'react';

const ChordDiagram = ({ chordData, name }) => {
  if (!chordData) return null;

  // FIX: Removed unused 'fingers' and 'capo'
  const { frets, barres } = chordData;
  const positiveFrets = frets.filter(fret => fret > 0);
  const maxFret = positiveFrets.length ? Math.max(...positiveFrets) : 0;
  const baseFret = maxFret > 4 ? Math.min(...positiveFrets) : 1;
  const displayFrets = positiveFrets.map(fret => fret - baseFret + 1);
  const visibleFretCount = Math.max(4, displayFrets.length ? Math.max(...displayFrets) : 4);
  
  // Grid settings
  const width = 112;
  const height = 44 + visibleFretCount * 20;
  const xOffset = 28;
  const yOffset = 24;
  const stringSpacing = 12;
  const fretSpacing = 20;
  const getDisplayFret = (fret) => fret - baseFret + 1;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <text x={width / 2} y={15} textAnchor="middle" fontWeight="bold" fontSize="14">
        {name}
      </text>

      {/* --- STRINGS (Vertical Lines) --- */}
      {[0, 1, 2, 3, 4, 5].map(i => (
        <line
          key={`str-${i}`}
          x1={xOffset + i * stringSpacing}
          y1={yOffset}
          x2={xOffset + i * stringSpacing}
          y2={yOffset + visibleFretCount * fretSpacing} 
          stroke="#333"
          strokeWidth="1"
        />
      ))}

      {/* --- FRETS (Horizontal Lines) --- */}
      {Array.from({ length: visibleFretCount + 1 }).map((_, i) => (
        <line
          key={`fret-${i}`}
          x1={xOffset}
          y1={yOffset + i * fretSpacing}
          x2={xOffset + 5 * stringSpacing}
          y2={yOffset + i * fretSpacing}
          stroke="#333"
          strokeWidth={i === 0 && baseFret === 1 ? "3" : "1"} 
        />
      ))}

      {baseFret > 1 && (
        <text x={4} y={yOffset + 14} fontSize="11" fontWeight="bold" fill="#333">
          {baseFret}fr
        </text>
      )}

      {/* --- DOTS (Fingers) --- */}
      {frets.map((fret, stringIndex) => {
        if (fret <= 0) return null; 
        const displayFret = getDisplayFret(fret);
        
        return (
          <circle
            key={`dot-${stringIndex}`}
            cx={xOffset + stringIndex * stringSpacing}
            cy={yOffset + (displayFret * fretSpacing) - (fretSpacing / 2)}
            r="4"
            fill="#333"
          />
        );
      })}

      {/* --- BARRES (Curved lines across strings) --- */}
      {barres && barres.map((fret, i) => {
         const stringsWithBarre = frets
            .map((f, idx) => (f === fret ? idx : -1))
            .filter(idx => idx !== -1);
         
         if (stringsWithBarre.length < 2) return null;

         const startStr = Math.min(...stringsWithBarre);
         const endStr = Math.max(...stringsWithBarre);

         return (
           <rect
             key={`barre-${i}`}
             x={xOffset + startStr * stringSpacing - 4}
             y={yOffset + (getDisplayFret(fret) * fretSpacing) - (fretSpacing / 1.5)}
             width={(endStr - startStr) * stringSpacing + 8}
             height={10}
             rx={5}
             fill="#333"
             opacity="0.8"
           />
         );
      })}

      {/* --- TOP MARKERS (X and O) --- */}
      {frets.map((fret, i) => {
        if (fret === -1) {
          return (
            <text key={`mute-${i}`} x={xOffset + i * stringSpacing} y={yOffset - 5} textAnchor="middle" fontSize="10">X</text>
          );
        }
        if (fret === 0) {
          return (
            <circle key={`open-${i}`} cx={xOffset + i * stringSpacing} cy={yOffset - 8} r="3" stroke="#333" fill="none" />
          );
        }
        return null;
      })}
    </svg>
  );
};

export default ChordDiagram;
